export const baseURL = "https://hfsl-backend.herokuapp.com";
